import { confirm } from 'owa-confirm-dialog';
import removeInfoBarMessageInReadingPane from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import { getSelectedTableView } from 'owa-mail-list-store';
import { readingPaneStore } from 'owa-mail-reading-pane-store';
import strings from 'owa-strings/owa-common-strings';
import { mutator } from 'satcheljs';
import { UnsubscribeResponseType, onAfterUnsubscribe, UnsubscribeSourceType, } from 'owa-brands-subscription';
export default mutator(onAfterUnsubscribe, function (actionMessage) {
    if (actionMessage.unsubscribeSourceType !== UnsubscribeSourceType.BrandSubscriptionCard) {
        return;
    }
    if (actionMessage.responseType === UnsubscribeResponseType.Success) {
        var listViewType = getSelectedTableView().tableQuery.listViewType;
        if (listViewType == 0 /* Conversation */) {
            var itemPartsMap = readingPaneStore.conversationReadingPaneViewState.itemPartsMap;
            itemPartsMap.forEach(function (itemPart) {
                removeInfoBarMessageInReadingPane(itemPart, 'unsubscribeInfoBar');
            });
        }
        else {
            removeInfoBarMessageInReadingPane(readingPaneStore.itemReadingPaneViewState.itemViewState, 'unsubscribeInfoBar');
        }
    }
    else {
        confirm('', strings.actionGenericError, false, {
            hideCancelButton: true,
        });
    }
});
//# sourceMappingURL=onAfterUnsubscribeFromPersonaCardRemoveInfoBar.js.map